<template>
  <footer class="public-footer py-8 px-4 mt-16">
    <VaDivider class="mb-8" />
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- Company Info -->
        <div>
          <VuesticLogo class="mb-4" />
          <p class="text-secondary text-sm">Building a happier planet together.</p>
        </div>

        <!-- Product Links -->
        <div>
          <h3 class="font-semibold mb-4">Product</h3>
          <ul class="space-y-2">
            <li>
              <RouterLink to="/pricing" class="text-secondary hover:text-primary text-sm"> Pricing </RouterLink>
            </li>
            <li>
              <RouterLink to="/docs" class="text-secondary hover:text-primary text-sm"> Documentation </RouterLink>
            </li>
          </ul>
        </div>

        <!-- Company Links -->
        <div>
          <h3 class="font-semibold mb-4">Company</h3>
          <ul class="space-y-2">
            <li>
              <RouterLink to="/" class="text-secondary hover:text-primary text-sm"> About </RouterLink>
            </li>
            <li>
              <a href="#" class="text-secondary hover:text-primary text-sm"> Contact </a>
            </li>
          </ul>
        </div>

        <!-- Legal Links -->
        <div>
          <h3 class="font-semibold mb-4">Legal</h3>
          <ul class="space-y-2">
            <li>
              <a href="#" class="text-secondary hover:text-primary text-sm"> Privacy Policy </a>
            </li>
            <li>
              <a href="#" class="text-secondary hover:text-primary text-sm"> Terms of Service </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Copyright -->
      <div class="mt-8 pt-8 border-t border-backgroundBorder text-center">
        <p class="text-secondary text-sm">© {{ currentYear }} Happy Planet. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import VuesticLogo from './VuesticLogo.vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style lang="scss" scoped>
.public-footer {
  background-color: var(--va-background-element);
  border-top: 1px solid var(--va-background-border);
}
</style>
